module.exports = __webpack_public_path__ + "img/img.535f88ca.png";